const SLICK_TRACK_PADDING = 16; // ml-4
const THUMBNAIL_IMAGE_PADDING_RIGHT = 16; // mr-4

function getSlideSize({ wrapper, isHorizontal, isMobile }) {
	if (isMobile) {
		return wrapper.offsetWidth;
	}

	const style = window.getComputedStyle(wrapper);
	if (isHorizontal) {
		const marginLeft = parseFloat(style.marginLeft) || 0;
		const marginRight = parseFloat(style.marginRight) || 0;
		return wrapper.offsetWidth + marginLeft + marginRight;
	}

	const marginTop = parseFloat(style.marginTop) || 0;
	const marginBottom = parseFloat(style.marginBottom) || 0;
	return wrapper.offsetHeight + marginTop + marginBottom;
}

function centerThumbnailInView({
	enableCenter = false,
	containerRef,
	carouselIndex,
	timeout = 0,
	isHorizontalLayout = true,
	isMobile = false,
	setThumbnailActivePos,
	setRightTranslateX
}) {
	if (!enableCenter) {
		return;
	}

	requestAnimationFrame(() => {
		const container = containerRef.current;
		if (!container) return;

		const buttons = container.querySelectorAll('button[role="tab"]');
		const slickTrack = container.querySelector('.slick-track');

		if (!slickTrack || !buttons[carouselIndex]) {
			return;
		}

		setTimeout(() => {
			const slides = slickTrack.querySelectorAll('.slick-slide');
			const slideSizes = Array.from(slides, (slide) =>
				getSlideSize({
					wrapper: slide,
					isHorizontal: isHorizontalLayout,
					isMobile
				})
			);

			const currentSize = slideSizes[carouselIndex] || 0;
			const halfCurrentSize = currentSize / 2;

			// Calculate totals in single pass
			let totalWidthPrev = 0;
			let totalWidthNext = 0;
			let totalThumbnailWidth = 0;

			for (let i = 0; i < slideSizes.length; i++) {
				const size = slideSizes[i];
				totalThumbnailWidth += size;
				if (i <= carouselIndex) totalWidthPrev += size;
				if (i >= carouselIndex) totalWidthNext += size;
			}

			let viewportWidth;
			if (isMobile) {
				viewportWidth = window.innerWidth;
			} else if (isHorizontalLayout) {
				viewportWidth = container.clientWidth;
			} else {
				viewportWidth = container.clientHeight;
			}

			const windowHalf = viewportWidth / 2;
			const isVertical = !isMobile && !isHorizontalLayout;

			const isNearStart = totalWidthPrev - halfCurrentSize <= windowHalf;
			const isNearEnd = totalWidthNext - halfCurrentSize <= windowHalf;

			let lastThumbnailTranslateX =
				totalThumbnailWidth -
				viewportWidth -
				THUMBNAIL_IMAGE_PADDING_RIGHT;
			if (isMobile && carouselIndex === slideSizes.length - 1) {
				lastThumbnailTranslateX += SLICK_TRACK_PADDING;
			}
			let offset;
			if (isNearStart || totalThumbnailWidth < viewportWidth) {
				offset = 0;
			} else if (isNearEnd) {
				let scrollPosition =
					totalThumbnailWidth -
					viewportWidth -
					THUMBNAIL_IMAGE_PADDING_RIGHT;
				if (isMobile && carouselIndex === slideSizes.length - 1) {
					scrollPosition += SLICK_TRACK_PADDING;
				}
				offset = -scrollPosition;
			} else {
				offset =
					windowHalf -
					totalWidthPrev +
					halfCurrentSize +
					THUMBNAIL_IMAGE_PADDING_RIGHT / 2;
			}
			setRightTranslateX(-lastThumbnailTranslateX);
			setThumbnailActivePos(offset);
			const transform = isVertical
				? `translate3d(0, ${offset}px, 0)`
				: `translate3d(${offset}px, 0, 0)`;

			slickTrack.style.setProperty('transform', transform, 'important');
		}, timeout);
	});
}

export { centerThumbnailInView, getSlideSize };
